module.exports = __webpack_public_path__ + "img/item.2ea85029.png";